import { ENV, globalOptions } from './global_options';
let cachedDevTools;
const getDevTools = () => {
    if (!ENV.DEV)
        return null;
    if (cachedDevTools === undefined) {
        cachedDevTools =
            globalOptions.devTools ||
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                globalThis.__glassEaselDevTools__;
    }
    return cachedDevTools;
};
export const performanceMeasureStart = (type, comp = null, data) => {
    var _a;
    const perf = (_a = getDevTools()) === null || _a === void 0 ? void 0 : _a.performance;
    perf === null || perf === void 0 ? void 0 : perf.addTimelinePerformanceMeasureStart(perf.now(), type, comp, data);
};
export const performanceMeasureEnd = () => {
    var _a;
    const perf = (_a = getDevTools()) === null || _a === void 0 ? void 0 : _a.performance;
    perf === null || perf === void 0 ? void 0 : perf.addTimelinePerformanceMeasureEnd(perf.now());
};
export const performanceMeasureRenderWaterfall = (type, waterfallType, comp, render) => {
    var _a, _b, _c;
    const perf = (_a = getDevTools()) === null || _a === void 0 ? void 0 : _a.performance;
    if (!perf) {
        render();
        return;
    }
    const pendingTimestamp = perf.now();
    const nodeTreeContext = comp.getBackendContext();
    if (nodeTreeContext) {
        const measureId = (_b = nodeTreeContext.performanceTraceStart) === null || _b === void 0 ? void 0 : _b.call(nodeTreeContext);
        performanceMeasureStart(type, comp);
        render();
        performanceMeasureEnd();
        (_c = nodeTreeContext.performanceTraceEnd) === null || _c === void 0 ? void 0 : _c.call(nodeTreeContext, measureId, ({ startTimestamp, endTimestamp }) => {
            perf.addTimelineBackendWaterfall(waterfallType, [
                pendingTimestamp,
                startTimestamp,
                endTimestamp,
            ]);
        });
    }
    else {
        render();
    }
};
export const addTimelineEvent = (type, data) => {
    var _a;
    const perf = (_a = getDevTools()) === null || _a === void 0 ? void 0 : _a.performance;
    perf === null || perf === void 0 ? void 0 : perf.addTimelineEvent(perf.now(), type, data);
};
export const attachInspector = (elem) => {
    var _a;
    if (!ENV.DEV)
        return;
    const inspector = (_a = getDevTools()) === null || _a === void 0 ? void 0 : _a.inspector;
    inspector === null || inspector === void 0 ? void 0 : inspector.addMountPoint(elem, {});
};
export const detachInspector = (elem) => {
    var _a;
    if (!ENV.DEV)
        return;
    const inspector = (_a = getDevTools()) === null || _a === void 0 ? void 0 : _a.inspector;
    inspector === null || inspector === void 0 ? void 0 : inspector.removeMountPoint(elem);
};
//# sourceMappingURL=dev_tools.js.map